import { render, staticRenderFns } from "./PatchLocationsTemplate.vue?vue&type=template&id=33d5c736"
import script from "./PatchLocationsTemplate.vue?vue&type=script&lang=js"
export * from "./PatchLocationsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports